import React from "react";
import { Td, Tr } from "@chakra-ui/react";

/**
 * Hàng bộ lọc hiển thị ngay dưới hàng tiêu đề của bảng.
 *
 * Mục tiêu: tái sử dụng cho toàn bộ FE mà KHÔNG thay đổi logic/luồng lọc hiện có.
 * Component chỉ chịu trách nhiệm render lại các control lọc (đã có sẵn state/setter
 * ở trang cha) vào đúng ô của từng cột.
 *
 * Props:
 * - headers: mảng cột `{ key, label }` — dùng chính mảng headers của bảng để số ô
 *   và thứ tự luôn khớp với hàng tiêu đề.
 * - filters: map `columnKey -> React node`. Node là control lọc tái sử dụng
 *   state/setter sẵn có của trang. Cột không có filter sẽ render ô trống.
 * - leadingCells: số ô trống (number) hoặc mảng node chèn TRƯỚC các cột, để canh
 *   với những cột đầu bảng không nằm trong `headers` (vd cột checkbox).
 * - backgroundColor / tdProps: tuỳ biến hiển thị, mặc định theo style bảng nhân sự.
 */
export default function ColumnFilterRow({
  headers = [],
  filters = {},
  leadingCells = 0,
  backgroundColor = "var(--fill-avatar)",
  tdProps = {},
}) {
  const leading =
    typeof leadingCells === "number"
      ? Array.from({ length: Math.max(0, leadingCells) })
      : Array.isArray(leadingCells)
        ? leadingCells
        : [];

  return (
    <Tr backgroundColor={backgroundColor}>
      {leading.map((cell, index) => (
        <Td
          key={`lead-${index}`}
          p={"0px 16px 12px 16px"}
          border={"none"}
          verticalAlign={"top"}
          {...tdProps}
        >
          {React.isValidElement(cell) ? cell : null}
        </Td>
      ))}
      {headers.map((header, index) => (
        <Td
          key={index}
          p={"0px 16px 12px 16px"}
          border={"none"}
          verticalAlign={"top"}
          {...tdProps}
        >
          {filters?.[header?.key] || null}
        </Td>
      ))}
    </Tr>
  );
}
